import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import devices from "./modules/devices";
import businessprofile from "./modules/businessprofile";
import users from "./modules/users";
import myprofile from "./modules/myprofile";
import notifications from "./modules/notifications";
import subscriptions from "./modules/subscriptions";
import records from "./modules/records";
import dashboard from "./modules/dashboard";
import developers from "./modules/developers";
import groups from "./modules/groups";
import alarms from "./modules/alarm";
import wallet from "./modules/wallet";
import gricdstore from "./modules/gricdstore";
import reports from "./modules/reports";
import features from "./modules/features";
import support from "./modules/support";
import dispatch from "./modules/dispatch";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "vuex", // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

export default new Vuex.Store({
  modules: {
    auth,
    devices,
    dashboard,
    businessprofile,
    users,
    myprofile,
    notifications,
    subscriptions,
    records,
    developers,
    groups,
    alarms,
    wallet,
    gricdstore,
    reports,
    features,
    support,
    dispatch,
  },
  plugins: [vuexLocalStorage.plugin],
});
